import axiosInstance from './config/api';
import { CallDirectionType, CallType } from 'types/call.type';

const AGENT_CENTER_API_URL = '/agent-center';

interface StatusResponse {
    message: string;
}

export interface CallDetailsResponse {
    callDetails: {
        id: string;
        firstName: string;
        lastName: string;
        cellPhone: string;
        status: keyof typeof CallType;
        createdAt: string;
        updatedAt: string;
        metadata: Record<string, any>;
        workflowName: string;
        workflowId: string;
        callDirection: CallDirectionType;
    };
    statuses: string[];
    partyInfo: {
        partyId: string;
        partyStage: string;
    };
}

export interface QualificationsResponse {
    id: string;
    key: string;
    value: string;
    created_at: string;
}

export interface CallHistoryItem {
    callId: string;
    contactName: string;
    phoneNumber: string;
    callTime: string; // ISO 8601 datetime string
    duration: number;
    actionTaken: string;
}

export interface CallSnapshot {
    callsTaken: number;
    dealsWon: number;
    closingRate: number;
    hoursActive: number;
    avgWaitTime: number;
}

export interface LeadCategorization {
    lostDeals: number;
    followUp: number;
    awaitingDocs: number;
    disqualifiedLeads: number;
}

export interface AgentCenterResponse {
    agentOnline: boolean;
    callSnapshot: CallSnapshot;
    leadCategorization: LeadCategorization;
    callHistory: CallHistoryItem[];
    expectManualCallbacks: number;
}

export const getCallDetails = (callId: string) => {
    return axiosInstance.get<CallDetailsResponse>(`${AGENT_CENTER_API_URL}/call/${callId}`).then((res) => res.data);
};

export const putAgentAvailabileService = (available: boolean) => {
    return axiosInstance.put<StatusResponse>(`${AGENT_CENTER_API_URL}/online`, { online: available });
};

export const getQualifications = (callId: string) => {
    return axiosInstance
        .get<QualificationsResponse[]>(`${AGENT_CENTER_API_URL}/qualifications/${callId}`)
        .then((res) => res.data);
};

export const postBatchQualifications = (callIds: string[]) => {
    return axiosInstance
        .post<{
            qualifications: Record<string, QualificationsResponse[]>;
        }>(`${AGENT_CENTER_API_URL}/qualifications/batch`, { callIds })
        .then((res) => res.data);
};

export const updateCallStatus = ({
    callId,
    partyId,
    callStatus,
}: {
    callId: string;
    partyId: string;
    callStatus: keyof typeof CallType;
}) => {
    return axiosInstance
        .put<StatusResponse>(`${AGENT_CENTER_API_URL}/status`, {
            callId,
            partyId,
            callStatus,
        })
        .then((res) => res.data);
};

export const getAgentCenter = () => {
    return axiosInstance.get<AgentCenterResponse>(AGENT_CENTER_API_URL).then((res) => res.data);
};

export const putAgentAvailabileStatusById = ({ id, status }: { id: string; status: boolean }) => {
    return axiosInstance.put<StatusResponse>(`${AGENT_CENTER_API_URL}/offline/${id}`, { online: status });
};
